module.exports = __webpack_public_path__ + "static/img/logo80.4bb2970.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo80.png
// module id = EEdm
// module chunks = 1